import ParameterErrors from '../errors/ParameterErrors';
import SiteJsonUnitPlotRooms from './SiteJsonUnitPlotRooms';
import Vector2 from '../geometry/Vector2';
import Location from '../modelling/Location';
import UrlHelper from '../core/UrlHelper';
import Urls from '../urls/Urls';
import PlotStatus from './PlotStatus';
import HouseTypes from './HouseTypes';
import RoomType from './RoomType';
import eventEnable from '../core/eventEnable';
import Handles from '../core/Handles';
import enableAcceptBindings from '../mvvm/enableAcceptBindings';
import exposeBinding from '../mvvm/exposeBinding';
import DynamicImage from '../images/DynamicImage';
import numberWithCommas from '../core/numberWithCommas';
import PropertyBindingFactory from '../mvvm/PropertyBindingFactory';
const { throwNotProvided, throwNotOfType} = ParameterErrors;
export default class SiteJsonUnitPlot{
	constructor(props){
		eventEnable(this);
		enableAcceptBindings(this);
		const {getUnit, name, number, rooms, affordable, frontViewImage, price, status, 
		houseType, selected, floorPlanImages, currencyConfiguration}=props;
		
		if(name===undefined||name===null)
			throwNotProvided('name');
		
		if(number===undefined||number===null)
			throwNotProvided('number');
		
		if(typeof(number)!=='number')
			throwNotOfType('number', 'number');
		
		
		/*if(frontViewImageRelativePath===undefined || frontViewImageRelativePath===null)
			throwNotProvided('frontViewImageRelativePath');*/
		
		if(status===undefined || status===null)
			throwNotProvided('status');
		
		if(houseType===undefined || houseType===null)
			throwNotProvided('houseType');
		this._getUnit = getUnit;
		this._hash = `plot_${number}_${name}`;
		this._name = name;
		this._number = number;
		this._rooms = rooms;
		this._affordable = affordable;
		this._frontViewImage=frontViewImage;
		this._price=price;
		this._status = status;
		this._houseType = houseType;
		this._floorPlanImages = floorPlanImages;
		this._selected = selected?true:false;
		this._currencyConfiguration =currencyConfiguration;
		this._houseTypeFeaturesChanged = this._houseTypeFeaturesChanged.bind(this);
		this.toJSON = this.toJSON.bind(this);
		exposeBinding(this, 'selected', ()=>this.selected, (value)=>this.selected = value);
		exposeBinding(this, 'status', ()=>this.status, (value)=>this.status = value);
		exposeBinding(this, 'features', ()=>this.features, (value)=>this.features = value);
		exposeBinding(this, 'plotFeatures', ()=>this.plotFeatures, (value)=>this.plotFeatures = value);
		this._propertyBindingHouseTypeFeatures = PropertyBindingFactory.standard(this, this._houseType, 'features', this._houseTypeFeaturesChanged);
	}
	get unit(){
		return this._getUnit();
	}
	get hash(){
	    return this._hash;
	}
	get name(){
		return this._name;
	}
	get about(){
		return this._houseType.about;
	}
	get number(){
		return this._number;
	}
	get rooms(){
		return this._rooms;
	}
	get affordable(){
		return this._affordable;
	}
	get frontViewImage(){
		return this._frontViewImage;
	}
	get price(){
		return this._price;
	}
	set price(value){
		this._price = value;
	}
	get status(){
		return this._status;
	}
	set status(value){
		this._status=value;
	}
	get isSold(){
		return this._status===PlotStatus.SOLD_OR_UNAVAILABLE;
	}
	get isReserved(){
		return this._status===PlotStatus.RESERVED;
	}
	get isAvailable(){
		return this._status===PlotStatus.AVAILABLE;
	}
	get nBedrooms(){
		return this._houseType.nBedrooms;
		//return this._rooms.getArray().filter(room=>room.roomType===RoomType.BEDROOM).length;
	}
	get nBathrooms(){
		return this._houseType.nBathrooms
	}
	get houseType(){
		return this._houseType;
	}
	get priceString(){
		return `${this._currencyConfiguration.currencyPrefix}${numberWithCommas(this.price)}${this._currencyConfiguration.currencySuffix}`;
	}
	get selected(){
		return this._selected;
	}
	set selected(value){
		const oldValue = this._selected;
		this._selected = value;
		if(oldValue!==value){
			this.bindingsHandler.changed('selected', value);
			this.dispatchEvent({type:'selectedChanged'});
		}
	}
	get floorPlanImages(){
		return this._floorPlanImages;
	}
	get hasOneOrMoreRoomImages(){
		console.log('hasOneOrMoreRoomImages ');
		console.log(this.rooms);
		if(!this.rooms)return false;
		const rooms = this.rooms.getArray();
		console.log(rooms);
		for(var i=0; i<rooms.length; i++){
			const room = rooms[i];
			if(room.images&&room.images.length>0){
				return true;
			}
		}
		return false;
	}
	get features(){
		let value = [];
		if(this._houseType.features)
			value =value.concat(this._houseType.features);
		if(this.plotFeatures)
			value = value.concat(this.plotFeatures);
		return value;
	}
	get plotFeatures(){
		return this._plotFeatures;
	}
	set plotFeatures(value){
		this._plotFeatures= value;
		this.bindingsHandler.changed('plotFeatures');
		this.bindingsHandler.changed('features');
		this.dispatchEvent({type:'plotfeatureschanged', plotFeatures:this._plotFeatures});
	}
	_houseTypeFeaturesChanged(){
		this.bindingsHandler.changed('features');
	}
	toJSON(){
		return {
			name:this._name,
			number:this._number,
			frontViewImageRelativePath:this._frontViewImageRelativePath,
			price:this._price,
			status:PlotStatus.toString(this.status),
			houseType:this._houseType.name,
			selected:this._selected
		};
	}
	static fromJSON(jObject, houseTypes, currencyConfiguration, getUnit){
		if(jObject.number===undefined||jObject.number===null)
			throwNotProvided('jObject.number (number of the number)');
		let plot=null;
		const getParentPlot=()=>{return plot;}
		plot =  new SiteJsonUnitPlot({
			name:jObject.name,
			number:jObject.number,
			rooms:jObject.rooms?SiteJsonUnitPlotRooms.fromJSON(jObject.rooms, getParentPlot):[],
			affordable:jObject.affordable||(jObject.houseType===undefined||jObject.houseType===null||jObject.houseType===''),
			frontViewImage:jObject.frontViewImage?DynamicImage.fromJSON(jObject.frontViewImage):null,
			price:jObject.price,
			status:PlotStatus.parse(jObject.status),
			houseType:houseTypes.parse(jObject.houseType),
			selected:jObject.selected,
			currencyConfiguration:currencyConfiguration,
			floorPlanImages:jObject.floorPlanImages?.map(floorPlanImage=>DynamicImage.fromJSON(floorPlanImage)),
			getUnit:getUnit
		});
		return plot;
	}
}